//Initialize Accordion
new Accordion(".accordion-container");

//Carousel Script
//document.querySelectorAll(".glide__slides")
if (document.querySelector(".glide__slides")) {

  var allSlides = document.querySelectorAll(".glide");
  var allSlidesArray = Array.prototype.slice.call(allSlides);
  allSlidesArray.forEach((slide) => {

    const glide = new Glide(slide, {
      type: "slider",
      perView: 3,
      perTouch: 1,
      focusAt: 'center',
      autoplay: false,
      accessibility: true,
      startAt: 2,
      rewind: false,
      classes: {
        disabledArrow: 'glide__arrow--disabled'
      },
      peek: {
        before: 100,
        after: 50
      },
      perSwipe: "|",
      breakpoints: {
        800: {
          perView: 1,
          peek: 0
        }
      }
    }).mount();

  });
};

// $('.glide__arrow--right').on('click', function () {
//   $('.glide__arrow--right').removeClass('disabled');

//   var totalslides = $('.glide__bullet').length;

//   if ($('.glide__bullet')[totalslides - 1].hasClass('glide__bullet--active')) {
//     console.log('last');
//     $('.glide__arrow--right').addClass('disabled');
//   }
// })

//Check if Header Button link is external
if (document.querySelector('.cta-btn')) {
  let currentHost = window.location.hostname;
  let ctaBtn = document.querySelector('.cta-btn');
  let ctaLink = ctaBtn.getAttribute("href").split('/');

  if (ctaLink[0] !== currentHost) {
    ctaBtn.classList.add("external-link");
  }
}

//Menu
$(document).ready(function () {
  "use strict";
  $('.menu-main-menu-container > ul > li:has( > ul)').addClass('menu-dropdown-icon');
  $('.menu-main-menu-container > ul > li > ul:not(:has(ul))').addClass('normal-sub');
  $(".menu-main-menu-container > ul").before("<div class=\"container\"><a href=\"#\" class=\"menu-mobile\"><span></span><span class=\"screen-reader-text\">Menu Toggle</span></a></div>");
  $(".menu-main-menu-container > ul > li").hover(function (e) {
    if ($(window).width() > 943) {
      $(this).children("ul").stop(true, false).fadeToggle(150).attr('aria-expanded', true);
      e.preventDefault();
    }
  });

  // $(".menu-main-menu-container > ul > li").on('mouseenter click', function (e) {
  //   if ($(window).width() > 943) {
  //     $(this).children("ul").stop(true, false).fadeIn(150).attr('aria-expanded', true).attr('aria-label');
  //     e.preventDefault();
  //   }
  // });
  // $(".menu-main-menu-container > ul > li").on('mouseleave', function (e) {
  //   if ($(window).width() > 943) {
  //     $(this).children("ul").stop(true, false).fadeOut(150).attr('aria-expanded', false);
  //     e.preventDefault();
  //   }
  // });
  $(".menu-main-menu-container > ul > li").click(function () {
    if ($(window).width() <= 943) {
      $(this).children("ul").fadeToggle(150);
    }
  });
  $(".menu-mobile").click(function (e) {
    $(".menu-main-menu-container > ul").toggleClass('show-on-mobile');
    $(".menu-mobile").toggleClass('active-menu');
    $("#overlay").fadeToggle();
    e.preventDefault();
  });
});
$(window).resize(function () {
  $(".menu-main-menu-container > ul > li").children("ul").hide();
  $(".menu-main-menu-container > ul").removeClass('show-on-mobile');
});

var spanChevron = $('<span />').attr('class', 'arrowchevron').attr('tabindex', 0).html('');
$('.menu-item-has-children > a').append(spanChevron);

let menuSubmenu = document.querySelectorAll('.menu-item-has-children');
let allmenuSubmenu = Array.prototype.slice.call(menuSubmenu);
allmenuSubmenu.forEach((menu) => {

  let parentName = menu.firstChild.textContent;

  menu.children[0].setAttribute('aria-haspopup', 'true');
  menu.children[1].setAttribute('aria-expanded', false);
  menu.children[1].setAttribute('aria-label', parentName + ' Submenu');

  let abc = menu.children[0];
  abc.children[0].innerHTML = '<span class="screen-reader-text">Open ' + parentName + ' Submenu</span>';
});


$('.menu-item-has-children > a').on('click', function (e) {
  // console.log('link clicked');
  // if ($(this).next().css('display') == 'none') {
  //   e.preventDefault();
  //   $(this).closest('.arrowchevron').addClass('close-submenu');
  // } else {
  //   $(this).closest('.arrowchevron').removeClass('close-submenu');
  // }
})

$('.arrowchevron').on('keypress click', function (e) {  
  $(this).parent().next().fadeToggle(150);
  $(this).toggleClass('close-submenu');

  // if ($(this).parent().next().css('display') == 'none') {
  //   $('.arrowchevron').addClass('close-submenu');
  // } else {
  //   $('.arrowchevron').removeClass('close-submenu');
  // }
  e.preventDefault();
});

////Pagination 
if (document.querySelector(".navigation-pagination")) {
  let paginationList = document.querySelectorAll('.navigation-pagination ul li');

  if (paginationList[0].classList.contains("active")) {
    paginationList[0].style.position = "relative";
  }

  if (paginationList[paginationList.length - 1].classList.contains("active")) {
    paginationList[paginationList.length - 1].style.position = "relative";
  }
}

// if ($('.page-heading.only-desktop').length != 0) {
//   $('article.page').css('padding', 0);
// }

////////Glide
if (document.querySelector('.allcontainer')) {
  var elem = document.querySelector('.allcontainer');
  var msnry = new Masonry(elem, {
    // options
    itemSelector: '.item',
    columnWidth: '.grid-sizer',
    gutter: 15,
  });

  //Filters
  // const filterBtn = document.querySelectorAll('.filters button');    
  // var allfilterBtn = Array.prototype.slice.call(filterBtn);
  //let allblocks = document.querySelectorAll('.item');
  let allblocks = Array.prototype.slice.call(document.querySelectorAll('.item'));
  let selectedValue;
  let selectedOption;
  let availableItems;
  let buttons = document.querySelectorAll('.filters button'); //returns a nodelist

  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", onClickChange);
  }

  //Click Filter
  function onClickChange() {
    selectedValue = this.value;

    // if(selectedValue !== 'all'){
    //   allblocks = document.querySelectorAll('.item.block');
    // }
    allblocks.forEach(function (block) {
      block.classList.remove('block');

      if (selectedValue == 'all') {
        block.classList.add('block');
      }

      if (block.getAttribute('data-cat') == selectedValue) {
        block.classList.add('block');
      }
    });
    msnry.layout();

    availableItems = Array.prototype.slice.call(document.querySelectorAll('.item.block'));
    document.getElementById('select').addEventListener("change", onSelectChange);

  }


  availableItems = Array.prototype.slice.call(document.querySelectorAll('.item.block'));

  document.getElementById('select').addEventListener("change", onSelectChange);

  function onSelectChange() {
    selectedOption = this.value;

    availableItems.forEach(function (item) {
      item.classList.remove('block');

      if (selectedOption == 'all') {
        item.classList.add('block');
      }

      if (item.getAttribute('data-tag') == selectedOption) {
        item.classList.add('block');
      }
    });

    //Filter Click
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", onClickChange);
    }

    msnry.layout();
  }

  /////Script_AJAX
  /* Ajax functions */
  $(document).ready(function () {
    //onclick
    $("#loadMore").on('click', function (e) {
      e.preventDefault();
      //init
      var that = $(this);
      var page = $(this).data('page');
      var newPage = page + 1;
      var ajaxurl = that.data('url');
      //ajax call
      $.ajax({
        url: ajaxurl,
        type: 'post',
        data: {
          page: page,
          action: 'ajax_script_load_more'

        },
        error: function (response) {
          console.log(response);
        },
        success: function (response) {
          //check
          if (response == 0) {
            $('.allcontainer').append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
            $('#loadMore').hide();
          } else {
            that.data('page', newPage);
            $('#ajax-primary').append(response);

            msnry = new Masonry(elem, {
              // options
              itemSelector: '.item',
              columnWidth: '.grid-sizer',
              gutter: 15,
            });

            msnry.layout();
          }

        }
      });

    });
  });
}

////Gallery Lightbox
// let allGallery = document.querySelectorAll('.wp-block-gallery');

// if (allGallery) {
//   allGallery.forEach(gallery => {
//     gallery.classList += ' gallery-with-modal';
//   });
// }

$('#onetrust-group-container').on('click', 'button', function () {
  $('.skip-link').blur();
  $('.custom-logo-link').focus();
});

//Hero Banner Animation
let we = document.querySelector('.we'),
  customtext = document.querySelector('.customtext'),
  sw_s = document.querySelector('.sw_s'),
  sw_o = document.querySelector('.sw_o'),
  sw_u = document.querySelector('.sw_u'),
  sw_t = document.querySelector('.sw_t'),
  sw_h = document.querySelector('.sw_h'),
  sw_w = document.querySelector('.sw_w'),
  sw_ao = document.querySelector('.sw_a-o'),
  sw_a_anim = document.querySelector('.sw_a-anim'),
  sw_o_anim = document.querySelector('.sw_o-anim'),
  sw_r = document.querySelector('.sw_r'),
  sw_k = document.querySelector('.sw_k'),


  tl = new TimelineLite();

tl.to(sw_k, 0.2, { autoAlpha: 0.3, x: 50 })
  .to(sw_r, 0.2, { autoAlpha: 0.3, x: 50 }, '-=0.1')
  .to(sw_ao, 0.2, { autoAlpha: 0.3, x: 50 }, '-=0.1')
  .to(sw_w, 0.2, { autoAlpha: 0.3, x: 50 }, '-=0.1')
  .to(sw_h, 0.2, { autoAlpha: 0.3, x: 50 }, '-=0.1')
  .to(sw_t, 0.2, { autoAlpha: 0.3, x: 50 }, '-=0.1')
  .to(sw_u, 0.2, { autoAlpha: 0.3, x: 50 }, '-=0.1')
  .to(sw_o, 0.2, { autoAlpha: 0.3, x: 50 }, '-=0.1')
  .to(sw_s, 0.2, { autoAlpha: 0.3, x: 50 }, '-=0.1')

  .to(sw_k, 0.2, { autoAlpha: 0.5, x: 40 }, '-=0.1')
  .to(sw_r, 0.2, { autoAlpha: 0.5, x: 40 }, '-=0.1')
  .to(sw_ao, 0.2, { autoAlpha: 0.5, x: 40 }, '-=0.1')
  .to(sw_w, 0.2, { autoAlpha: 0.5, x: 40 }, '-=0.1')
  .to(sw_h, 0.2, { autoAlpha: 0.5, x: 40 }, '-=0.1')
  .to(sw_t, 0.2, { autoAlpha: 0.5, x: 40 }, '-=0.1')
  .to(sw_u, 0.2, { autoAlpha: 0.5, x: 40 }, '-=0.1')
  .to(sw_o, 0.2, { autoAlpha: 0.5, x: 40 }, '-=0.1')
  .to(sw_s, 0.2, { autoAlpha: 0.5, x: 40 }, '-=0.1')

  .to(sw_k, 0.2, { autoAlpha: 1, x: 50 }, '-=0.1')
  .to(sw_r, 0.2, { autoAlpha: 1, x: 50 }, '-=0.1')
  .to(sw_ao, 0.2, { autoAlpha: 1, x: 50 }, '-=0.1')
  .to(sw_w, 0.2, { autoAlpha: 1, x: 50 }, '-=0.1')
  .to(sw_h, 0.2, { autoAlpha: 1, x: 50 }, '-=0.1')
  .to(sw_t, 0.2, { autoAlpha: 1, x: 50 }, '-=0.1')
  .to(sw_u, 0.2, { autoAlpha: 1, x: 50 }, '-=0.1')
  .to(sw_o, 0.2, { autoAlpha: 1, x: 50 }, '-=0.1')
  .to(sw_s, 0.2, { autoAlpha: 1, x: 50 }, '-=0.1');

tl.to(we, 0.5, { autoAlpha: 0.2, x: 50, ease: Power2.easeInOut }, '-=0.2')
  .to(we, 0.5, { autoAlpha: 0.5, x: -10 }, '-=0.2')
  .to(we, 0.5, { autoAlpha: 1, x: 10 }, '-=0.2')
  .to(customtext, 0.5, { autoAlpha: 0.2, x: 50, ease: Power2.easeInOut }, '-=0.2')
  .to(customtext, 0.5, { autoAlpha: 0.5, x: -10 }, '-=0.2')
  .to(customtext, 0.5, { autoAlpha: 1, x: 10 }, '-=0.2');

var tl2 = new TimelineMax({ delay: 3, repeat: -1, repeatDelay: 3 })
  .to(sw_a_anim, 0.4, { autoAlpha: 0 })
  .to(sw_o_anim, 0.4, { autoAlpha: 1 })
  .to(sw_o_anim, 0.4, { autoAlpha: 0 }, "+=3")
  .to(sw_a_anim, 0.4, { autoAlpha: 1 });

//Play Pause Buttons
playpauseBtn = document.querySelector('.playpausebtn');
var isPaused ='false';
if (playpauseBtn) {
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  $( document ).ready(function() {
    var isPaused = getCookie("isPaused");
    if (isPaused == 'true') {      
      tl.progress(1).pause();
      tl2.progress(1).pause();
      //tl.play();
      playpauseBtn.classList.remove('play');
      playpauseBtn.classList.add('paused');
      playpauseBtn.textContent = 'Play';
    };
});

  playpauseBtn.addEventListener('click', function () {

    if (this.classList.contains('play')) {          
      // tl.pause();
      // tl2.pause();
      tl.progress(1).pause();
      tl2.progress(1).pause();
      this.classList.add('paused');
      this.classList.remove('play');
      this.textContent = 'Play';
      document.cookie = "isPaused=true;SameSite=None; Secure;path=/";    

    } else {
     
      // tl.resume();
      // tl2.resume();
      tl.progress(0).play();
      tl2.progress(0).play();
      this.classList.remove('paused');
      this.classList.add('play');
      this.textContent = 'Pause';
      document.cookie = "isPaused=false;SameSite=None; Secure;path=/";     
    }
  })
}

//Removed class from coverblock
$(".wp-block-cover").removeClass("has-background-dim");

//Prefer Reduced Motion
var mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
mediaQuery.addEventListener('change', () => {
  tl.progress(1);
  tl2.progress(1);
});